import { render, staticRenderFns } from "./CaExpansionPanels.vue?vue&type=template&id=72246f05"
import script from "./CaExpansionPanels.vue?vue&type=script&lang=js"
export * from "./CaExpansionPanels.vue?vue&type=script&lang=js"
import style0 from "./CaExpansionPanels.vue?vue&type=style&index=0&id=72246f05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanels})
